var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-move-list",
      class: [{ invisible: _vm.inNormalMode }]
    },
    [
      _c("div", { staticClass: "modal-bg", on: { click: _vm.closeModal } }),
      _vm.currentAnalysis
        ? _c("div", { staticClass: "modal" }, [
            _c("header", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "engine-name" }, [
                _vm._v(_vm._s(_vm.currentAnalysis.engine))
              ]),
              _c(
                "div",
                { staticClass: "close-modal", on: { click: _vm.closeModal } },
                [_vm._v("x")]
              )
            ]),
            _c(
              "div",
              { staticClass: "move-list" },
              [
                _vm.startPlyNum % 2 === 1
                  ? [
                      _c("div", { staticClass: "move-num" }, [
                        _vm._v(_vm._s(_vm.startMoveNum))
                      ]),
                      _c("div", { staticClass: "move" }, [_vm._v("...")])
                    ]
                  : _vm._e(),
                _vm._l(_vm.analysisMoves, function(move, i) {
                  return [
                    (_vm.startPlyNum + i) % 2 === 0
                      ? _c("div", { staticClass: "move-num" }, [
                          _vm._v(_vm._s(_vm.startMoveNum + 1 + ~~(i / 2)) + ".")
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "move",
                        class: [
                          {
                            current:
                              _vm.$store.state.variationPositionIndex === i
                          }
                        ],
                        attrs: { "data-ply": _vm.startPlyNum + i },
                        on: {
                          click: function($event) {
                            _vm.gotoMove(i)
                          }
                        }
                      },
                      [_vm._v(_vm._s(move))]
                    )
                  ]
                })
              ],
              2
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b109097", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b109097","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/modal_move_list.vue
// module id = 240
// module chunks = 0